import { render, staticRenderFns } from "./SettingsConfig.vue?vue&type=template&id=797e59d6&scoped=true&"
import script from "./SettingsConfig.vue?vue&type=script&lang=js&"
export * from "./SettingsConfig.vue?vue&type=script&lang=js&"
import style0 from "./SettingsConfig.vue?vue&type=style&index=0&id=797e59d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e59d6",
  null
  
)

export default component.exports